/* MirthWell parent quiz, app version, round 5 (2026-10-10; round 6: minimum ages from the product field only). Loaded with defer by sections/mw-quiz.liquid; no other code needed.
   - Start opens a full-screen native <dialog> (showModal: focus trapped, Escape closes, the page behind is inert).
     One step per screen; every step is a browser-history entry, so the phone's back button goes to the previous question.
     Age and "who" are one-tap buttons. "Help with" (up to 3) and "loves" are toggle tiles with a Next button; "home" is
     checkboxes with a Next button. Every answer except the ages has a line icon (the drawings stay on the age tiles).
   - Round 5 (owner, less waiting): the thinking screen (the age drawing, one line, one TRUE tip = the band's first CDC
     milestone, 4.5 to 7 s by text length, a small Continue after 3 s) shows only after the AGE. The top progress bar is the
     only progress line (it fills toward the next step during the screen). After the other answers the picked tiles get a
     check and a soft pulse for about 1 s, then the next question slides in. Before the results, "Building your child's plan"
     ticks off its true steps. Never "AI". Reduced motion: the same text and time, no animation. Back / phone back cancel.
   - Closed with X (or Escape / phone back) before the end: the answers are kept (memory + sessionStorage); the next Start
     offers "Continue where you left off" or "Start over".
   - The toy index is fetched only after Start (or for a result link): <page>?view=quiz-data (templates/page.quiz-data.json).
     The result texts are an inert JSON block in the page, parsed on first need.
   - SAFETY RULES live here, never in settings: in stock; the band's age tag; minimum age at or below the band start
     (the product field custom.min_age_months, "From age (months)"; no field = hidden under 3 years);
     no small-parts warning under 36 months (unknown counts as small parts); never a blocked handle. Ranking: +3 for EACH
     chosen area the toy's skills match, +2 per loved activity, +1 travel, +1 best seller, +1 gift; ties: a different kind
     of toy first, then the toy made for the nearest age, then A-Z. At most 3; an empty slot is never filled from another age.
     "Why it fits" names only the tags that gave the score (areas, loves, travel); else "Picked for <age>".
   - Results: a personal summary card first (3 activities + 1 watch-for line; gift: 3 milestones + the AAP line), then the
     cards. Toys: the in-stock default variant's price (and its name when there are several), Add to cart through Shopify's
     Ajax cart (/cart/add.js), "Added" + View cart; the theme's cart is refreshed with its own "cart:build" event.
   - Shareable result: ?age=&for=&focus=a,b&loves=&home= (answers only). Analytics: mirthwell:quiz_start / quiz_complete
     with {band, focus} only (focus = comma list, or "all").
   - "Email me my plan": LIVE page only (data-preview="false"): Klaviyo client API (public site key, revision 2026-07-15):
     1. POST /client/subscriptions (email marketing consent SUBSCRIBED, list from settings, profile properties quiz_age_band,
     quiz_focus, quiz_loves, quiz_home), 2. POST /client/events "Quiz Completed" with the plan (age, focus, 3 activities,
     3 milestones, 3 set-up tips, 1 watch-for line, up to 3 toys, the result address). The preview and the theme editor send
     nothing ("Preview only").
   - Round 7 (owner 2026-10-11, "split the quiz into 4 and 5+"): the old band 4-5y is now two answers, 4y (48 months, tag
     age:4y) and 5y (60 months, tag age:5y). The old key stays in BANDS only so the page keeps working while the old template
     is still live (push this file first); once the template has no 4-5y band, an old link or saved answer with age=4-5y
     (shared links, the "See your full plan" button in plan emails already sent) opens the 4y plan (LEGACY). */
(function () {
  'use strict';
  var root = document.querySelector('[data-mwq]');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  var dlg = root.querySelector('[data-app]');
  var startBtn = root.querySelector('[data-start]');
  var resWrap = root.querySelector('[data-res]');
  var mail = root.querySelector('[data-mail]');
  var live = root.querySelector('[data-live]');
  if (!dlg || !startBtn || !resWrap) return;
  var bar = dlg.querySelector('[data-bar]');
  var backBtn = dlg.querySelector('[data-back]');
  var closeBtn = dlg.querySelector('[data-close]');
  var foot = dlg.querySelector('[data-foot]');
  var nextBtn = dlg.querySelector('[data-next]');
  var bodyEl = dlg.querySelector('[data-body]');
  var thinkEl = dlg.querySelector('[data-think]');
  var waitEl = dlg.querySelector('[data-wait]');
  var waitH = dlg.querySelector('[data-wait-h]');
  var waitPic = dlg.querySelector('[data-wait-pic]');
  var tipBox = dlg.querySelector('[data-wait-tip]');
  var tipText = dlg.querySelector('[data-wait-tip-text]');
  var goBtn = dlg.querySelector('[data-wait-go]');
  var buildPic = dlg.querySelector('[data-build-pic]');
  var buildEl = dlg.querySelector('[data-build]');
  var buildH = dlg.querySelector('[data-build-h]');
  var buildList = dlg.querySelector('[data-build-steps]');
  var resumeEl = dlg.querySelector('[data-resume]');
  var appLive = dlg.querySelector('[data-app-live]');
  var pickEl = dlg.querySelector('[data-pick]');
  var pickN = dlg.querySelector('[data-pick-n]');
  var pickFull = dlg.querySelector('[data-pick-full]');
  var STEP = {};
  [].forEach.call(dlg.querySelectorAll('[data-q]'), function (s) { STEP[s.getAttribute('data-q')] = s; });
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEY = 'mwq';

  /* ---------------- fixed rules ---------------- */
  var S5 = ['age', 'who', 'focus', 'loves', 'home'];
  var ALLF = ['moving', 'hands', 'talking', 'thinking', 'myself', 'calm', 'all'];
  var BABYF = ['moving', 'hands', 'talking', 'thinking', 'calm', 'all'];
  var ALLL = ['inout', 'sounds', 'copying', 'puzzles', 'books', 'drawing', 'climbing'];
  var BANDS = {
    'expecting': { start: 0, tag: 'age:0-12m', uses: '0-6m', steps: ['age', 'who', 'home'], focus: [], loves: [] },
    '0-6m': { start: 0, tag: 'age:0-12m', steps: ['age', 'who', 'focus', 'home'], focus: BABYF, loves: [] },
    '6-12m': { start: 6, tag: 'age:0-12m', steps: S5, focus: BABYF, loves: ['inout', 'sounds', 'books', 'climbing'] },
    '12-18m': { start: 12, tag: 'age:1y', steps: S5, focus: ALLF, loves: ['inout', 'sounds', 'copying', 'puzzles', 'books', 'climbing'] },
    '18-24m': { start: 18, tag: 'age:1y', steps: S5, focus: ALLF, loves: ALLL },
    '2-3y': { start: 24, tag: 'age:2y', steps: S5, focus: ALLF, loves: ALLL },
    '3-4y': { start: 36, tag: 'age:3y', steps: S5, focus: ALLF, loves: ALLL },
    '4y': { start: 48, tag: 'age:4y', steps: S5, focus: ALLF, loves: ALLL },
    '5y': { start: 60, tag: 'age:5y', steps: S5, focus: ALLF, loves: ALLL },
    '4-5y': { start: 48, tag: 'age:4-5y', steps: S5, focus: ALLF, loves: ALLL }   /* old band: used only while the old template is live */
  };
  var LEGACY = { '4-5y': '4y' };   /* an old answer whose band is gone from the template -> its new band */
  var UNDER3 = 36, MAX_TOYS = 3, MAX_FOCUS = 3;
  var FOCUS_SKILLS = { moving: ['skill:gross-motor'], hands: ['skill:fine-motor'], talking: ['skill:language'], thinking: ['skill:logic', 'skill:math'], myself: ['skill:practical-life'], calm: ['skill:sensory', 'skill:music'], all: [] };
  var LOVES_TYPE = { inout: 'type:sorting-stacking', sounds: 'type:musical', copying: 'type:pretend-play', puzzles: 'type:puzzle', books: 'type:matching-memory', drawing: 'type:art-drawing', climbing: 'type:balance-climbing' };
  var HOME = ['small', 'travel', 'sibling'];

  /* ---------------- data (parsed / fetched on first need) ---------------- */
  function has(a, x) { return a.indexOf(x) >= 0; }
  function lines(s) { return String(s || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(function (l) { return l && l.charAt(0) !== '#'; }); }
  function cells(l) { return l.split('|').map(function (c) { return c.trim(); }); }
  function words(c) { return c && c !== '-' ? c.split(/[\s,]+/).filter(Boolean) : []; }
  var deco = document.createElement('textarea');
  function decode(s) { deco.innerHTML = String(s || ''); return deco.value; }
  var D = null, T = {}, MAIL = {}, SHEET = '', BLOCKED = {}, PRODUCTS = null, indexP = null;
  function texts() {
    if (D) return D;
    var el = root.querySelector('script[data-mwq-texts]');
    try { D = JSON.parse(el ? el.textContent : '{}'); } catch (e) { D = {}; }
    T = D.t || {};
    MAIL = D.mail || {};
    SHEET = String(D.sheet || '');
    lines(D.blocked).forEach(function (l) { var h = l.replace(/#.*$/, '').trim(); if (h) BLOCKED[h] = 1; });
    return D;
  }
  function dataUrl() { return location.pathname + '?view=quiz-data'; }
  function loadIndex() {
    if (PRODUCTS) return Promise.resolve(PRODUCTS);
    if (!indexP) {
      indexP = fetch(dataUrl(), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) {
          var m = t.match(/<script type="application\/json" id="mwq-index">([\s\S]*?)<\/script>/);
          if (!m) throw new Error('no index');
          PRODUCTS = JSON.parse(m[1]).map(function (p, i) {
            return { h: p.h, t: decode(p.t), u: p.u, pr: decode(p.pr), pv: p.pv === true, av: p.av === true, sp: p.sp !== false, al: decode(p.al), mm: (typeof p.mm === 'number' && isFinite(p.mm) && p.mm >= 0) ? p.mm : null, tg: String(p.g || '').split('|').filter(Boolean), i: p.i, idx: i,
              v: (typeof p.v === 'number' && isFinite(p.v)) ? p.v : null, va: p.va === true, vp: decode(p.vp || ''), vt: decode(p.vt || '') };
          });
          return PRODUCTS;
        })
        .catch(function (e) { indexP = null; throw e; });
    }
    return indexP;
  }

  function band(key) {
    texts();
    var raw = D.b && D.b[key];
    if (!raw || !BANDS[key]) return null;
    var src = BANDS[key].uses ? (D.b[BANDS[key].uses] || {}) : raw;
    function two(s) { return lines(s).map(function (l) { var c = cells(l); return { tags: words(c[0]), short: c[1] || '', text: c.slice(2).join(' | ') || c[1] || '' }; }).filter(function (x) { return x.short; }); }
    return {
      key: key, label: raw.label, title: raw.title, gift: raw.gift, wh: raw.wh, pic: raw.pic || src.pic || null, gp: raw.gp, tag: raw.tag,
      sum: raw.sum || '', sumg: raw.sumg || '', sumt: raw.sumt || '',
      working: lines(src.w).map(function (l) { var c = cells(l); return { tags: words(c[0]), age: c[1] || '', short: c[2] || '', text: c.slice(3).join(' | ') || c[2] || '' }; }).filter(function (x) { return x.short; }),
      tries: two(src.tr), setup: two(src.su),
      watch: lines(src.wa).map(function (l) { var c = cells(l); return { short: c[0], text: c.slice(1).join(' | ') || c[0] }; }),
      read: lines(src.rd).map(function (l) { var c = cells(l); return { t: c[0], u: c[1] || '' }; }).filter(function (x) { return x.t && x.u; }),
      sources: lines(src.src).map(function (l) { var c = cells(l); return { t: c[0], u: c[1] || '' }; }).filter(function (x) { return x.t; }),
      more: raw.more ? { u: raw.more, t: raw.moreLabel } : null
    };
  }
  function common() { texts(); return lines(D.common).map(function (l) { var c = cells(l); return { tags: words(c[0]), short: c[1] || '', text: c[2] || c[1] || '', lt: c[3] || '', lu: c[4] || '' }; }); }

  /* ---------------- engine ---------------- */
  function asList(v) { return Array.isArray(v) ? v.slice() : String(v == null ? '' : v).split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  /* focus = up to 3 areas offered at this age, in the order picked; nothing (or "all") = ['all'] */
  function normalize(a) {
    a = a || {}; texts();
    var age = a.age;
    if (!(D.b && D.b[age]) && LEGACY.hasOwnProperty(age)) age = LEGACY[age];
    if (!BANDS[age] || !(D.b && D.b[age])) return null;
    var B = BANDS[age], loves = [], home = [], focus = [];
    asList(a.focus).forEach(function (x) { if (x !== 'all' && has(B.focus, x) && !has(focus, x) && focus.length < MAX_FOCUS) focus.push(x); });
    asList(a.loves).forEach(function (x) { if (has(B.loves, x) && !has(loves, x)) loves.push(x); });
    asList(a.home).forEach(function (x) { if (has(HOME, x) && !has(home, x)) home.push(x); });
    return { age: age, who: a.who === 'gift' ? 'gift' : 'me', focus: focus.length ? focus : ['all'], loves: loves, home: home };
  }
  function areas(ans) { return ans.focus[0] === 'all' ? [] : ans.focus; }
  /* the product field only (custom.min_age_months); null = no minimum age known = hidden for every age under 3 years */
  function minAge(p) { return p.mm; }
  function eligible(p, key) {
    var B = BANDS[key];
    if (!B || !p.av) return false;
    if (!has(p.tg, B.tag)) return false;
    texts();
    if (BLOCKED[p.h]) return false;
    var m = minAge(p);
    if (m === null) { if (B.start < UNDER3) return false; }
    else if (!(m <= B.start)) return false;
    if (B.start < UNDER3 && p.sp) return false;
    return true;
  }
  function typesOf(p) { return p.tg.filter(function (t) { return t.indexOf('type:') === 0; }); }
  function pickToys(ans) {
    if (!PRODUCTS) return null;
    var fl = areas(ans);
    var pool = PRODUCTS.filter(function (p) { return eligible(p, ans.age); }).map(function (p) {
      var sc = 0, why = { areas: [], loves: [], travel: false };
      fl.forEach(function (f) { if ((FOCUS_SKILLS[f] || []).some(function (t) { return has(p.tg, t); })) { sc += 3; why.areas.push(f); } });
      ans.loves.forEach(function (l) { if (has(p.tg, LOVES_TYPE[l])) { sc += 2; why.loves.push(l); } });
      if (has(ans.home, 'travel') && has(p.tg, 'feature:travel')) { sc += 1; why.travel = true; }
      if (has(p.tg, 'feature:best-seller')) sc += 1;
      if (ans.who === 'gift' && has(p.tg, 'occasion:gift')) sc += 1;
      var mn = minAge(p);
      return { p: p, sc: sc, fit: mn === null ? -1 : mn, why: why };
    });
    pool.sort(function (a, b) { return (b.sc - a.sc) || (b.fit - a.fit) || (a.p.idx - b.p.idx); });
    var out = [], used = {};
    while (out.length < MAX_TOYS && pool.length) {
      var top = pool[0].sc, pick = null;
      for (var i = 0; i < pool.length && pool[i].sc === top; i++) { if (!typesOf(pool[i].p).some(function (t) { return used[t]; })) { pick = pool[i]; break; } }
      if (!pick) pick = pool[0];
      typesOf(pick.p).forEach(function (t) { used[t] = 1; });
      out.push(pick);
      pool.splice(pool.indexOf(pick), 1);
    }
    return out;
  }
  function homeOk(x, ans) { var hk = x.tags.filter(function (t) { return has(HOME, t); }); return !hk.length || hk.some(function (t) { return has(ans.home, t); }); }
  /* all lines of the chosen areas first, taken in turn (area 1, area 2, area 3, area 1, ...), then the rest in order */
  function roundRobin(list, keys) {
    var rest = list.slice(), out = [], took = true;
    while (keys.length && took) {
      took = false;
      for (var k = 0; k < keys.length; k++) for (var i = 0; i < rest.length; i++) if (has(rest[i].tags, keys[k])) { out.push(rest.splice(i, 1)[0]); took = true; break; }
    }
    return out.concat(rest);
  }
  /* one line per chosen area first (the best one of that area), then the rest in their order */
  function onePerArea(list, keys) {
    var rest = list.slice(), out = [];
    keys.forEach(function (k) { for (var i = 0; i < rest.length; i++) if (has(rest[i].tags, k)) { out.push(rest.splice(i, 1)[0]); break; } });
    return out.concat(rest);
  }
  function compute(a) {
    var ans = normalize(a); if (!ans) return null;
    var b = band(ans.age); if (!b) return null;
    var gift = ans.who === 'gift', fl = areas(ans);
    var working = roundRobin(b.working, fl);
    var scored = b.tries.filter(function (x) { return homeOk(x, ans); }).map(function (x, i) {
      var s = 0;
      if (fl.some(function (f) { return has(x.tags, f); })) s += 1;
      if (ans.loves.some(function (l) { return has(x.tags, l); })) s += 2;
      if (x.tags.some(function (t) { return has(HOME, t); })) s += 2;
      return { x: x, s: s, i: i };
    }).sort(function (p, q) { return (q.s - p.s) || (p.i - q.i); }).map(function (o) { return o.x; });
    var tries = onePerArea(scored, fl).slice(0, 6);
    var setup = b.setup.filter(function (x) { return homeOk(x, ans); }).map(function (x, i) { return { x: x, k: x.tags.some(function (t) { return has(HOME, t); }) ? 0 : 1, i: i }; }).sort(function (p, q) { return (p.k - q.k) || (p.i - q.i); }).map(function (o) { return o.x; });
    return { ans: ans, band: b, gift: gift, working: working, tries: tries, setup: gift ? [] : setup, watch: gift ? [] : b.watch, common: gift ? [] : common(), toys: pickToys(ans), read: b.read };
  }

  /* ---------------- rendering ---------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function safeUrl(u) { u = String(u || ''); return /^(https?:\/\/|\/(?!\/))/i.test(u) ? u : '#'; }
  function svg(d, vb) { return '<svg viewBox="' + (vb || '0 0 24 24') + '" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>'; }
  var IC = {
    grow: svg('<path d="M12 21v-9"/><path d="M12 12c0-4.2 3-7 7.5-7 0 4.2-3 7-7.5 7z"/><path d="M12 15c0-3.3-2.4-5.6-6-5.6 0 3.3 2.4 5.6 6 5.6z"/>'),
    star: svg('<path d="M12 3.5l2.4 5 5.4.6-4 3.7 1.1 5.4L12 15.5l-4.9 2.7 1.1-5.4-4-3.7 5.4-.6z"/>'),
    shelf: svg('<path d="M3 20.5h18M3 12.5h18"/><path d="M5.5 12.5v-5h3.5v5M11 12.5V8.5h3v4M16.5 12.5v-6h2.5v6"/><path d="M6 20.5v-4.5h4v4.5M13.5 20.5v-3h4v3"/>'),
    shield: svg('<path d="M12 3l7 3v5.2c0 4.4-3 8.3-7 9.8-4-1.5-7-5.4-7-9.8V6z"/><path d="M9 12l2.2 2.2L15.5 10"/>'),
    toys: svg('<rect x="3.5" y="13.5" width="7" height="7" rx="1.2"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.2"/><path d="M12 3.5l4 7H8z"/>'),
    book: svg('<path d="M12 6.2C10 4.8 7.4 4.4 4 4.6v13c3.4-.2 6 .2 8 1.6 2-1.4 4.6-1.8 8-1.6v-13c-3.4-.2-6 .2-8 1.6zM12 6.2v13"/>'),
    heart: svg('<path d="M12 20s-7-4.4-7-9.6A4.1 4.1 0 0 1 12 7.6a4.1 4.1 0 0 1 7 2.8C19 15.6 12 20 12 20z"/>'),
    link: svg('<path d="M10 14a4 4 0 0 0 5.7 0l2.8-2.8a4 4 0 0 0-5.7-5.7l-.9.9M14 10a4 4 0 0 0-5.7 0l-2.8 2.8a4 4 0 0 0 5.7 5.7l.9-.9"/>'),
    edit: svg('<path d="M4 20l1-4.2L15.8 5a2.1 2.1 0 0 1 3 3L8.2 18.8z"/>'),
    tag: svg('<path d="M3.5 12.6V5.2c0-.9.7-1.7 1.7-1.7h7.4l7.9 7.9-9.1 9.1z"/><circle cx="8" cy="8" r="1.3"/>'),
    check: svg('<circle cx="12" cy="12" r="9"/><path d="M8 12.3l2.6 2.6L16.2 9"/>')
  };
  function pts(arr) { return arr.length ? '<ul class="mwq-pts" role="list">' + arr.map(function (p) { return '<li>' + p + '</li>'; }).join('') + '</ul>' : ''; }
  function more(html) { return html ? '<details class="mwq-more"><summary><span class="mwq-more__o">' + esc(T.more) + '</span><span class="mwq-more__c">' + esc(T.less) + '</span></summary><div class="mwq-more__in">' + html + '</div></details>' : ''; }
  function card(o) {
    return '<section class="mwq-card' + (o.cls ? ' ' + o.cls : '') + '" aria-labelledby="' + o.id + '"><div class="mwq-card__head"><span class="mwq-card__ic">' + o.icon + '</span><div class="mwq-card__ht"><h3 class="mwq-card__h" id="' + o.id + '">' + esc(o.title) +
      (o.badge ? ' <span class="mwq-free">' + esc(o.badge) + '</span>' : '') + '</h3>' + (o.sub ? '<p class="mwq-card__sub">' + esc(o.sub) + '</p>' : '') + '</div></div>' + pts(o.points || []) + (o.body || '') + more(o.more) + '</section>';
  }
  function marker(age) { return age ? ' <span class="mwq-age">' + esc(String(T.age_marker || '[age]').replace('[age]', age)) + '</span>' : ''; }
  function fullList(arr, cls, f) { return '<ul class="mwq-full' + (cls ? ' ' + cls : '') + '" role="list">' + arr.map(function (x) { return '<li>' + f(x) + '</li>'; }).join('') + '</ul>'; }
  function lc(s) { s = String(s || ''); return s.charAt(0).toLowerCase() + s.slice(1); }
  function joinAnd(n) { return n.length < 2 ? n.join('') : n.slice(0, -1).join(', ') + ' ' + (T.word_and || 'and') + ' ' + n[n.length - 1]; }
  function names(keys, dict, low) {
    var n = keys.map(function (k) { var v = (dict && dict[k]) || k; return low ? lc(v) : v; });
    if (n.length > 3) n = n.slice(0, 2).concat([T.word_more || 'more']);
    return joinAnd(n);
  }
  function ageWords(key) { if (key === 'expecting') return T.build_expecting_age || ''; var b = D.b && D.b[key]; return b ? lc(b.label) : ''; }
  function cartRoot() { var S = window.Shopify; return (S && S.routes && S.routes.root) || '/'; }
  /* why a toy fits: only the tags that gave it its score */
  function whyText(o, ans) {
    var L = D.labels || {}, r = [], w = o.why || { areas: [], loves: [], travel: false };
    w.areas.forEach(function (f) { r.push(lc((L.fshort && L.fshort[f]) || f)); });
    w.loves.forEach(function (l) { r.push((L.lshort && L.lshort[l]) || l); });
    if (w.travel && T.why_travel) r.push(T.why_travel);
    return r.length ? (T.why_label ? T.why_label + ' ' : '') + r.join(', ') : String(T.why_age || '').replace('[age]', ageWords(ans.age));
  }
  function priceOf(p) { return p.vp || ((p.pv && T.price_from ? T.price_from + ' ' : '') + p.pr); }
  function toyRow(o, ans) {
    var p = o.p;
    var i2 = p.i ? String(p.i).replace(/([?&](?:width|height)=)240\b/g, '$1480') : null;
    var cart = p.v && p.va ? '<div class="mwq-toy__cart"><button type="button" class="mwq-btn mwq-btn--cart" data-cart="' + esc(p.v) + '" data-title="' + esc(p.t) + '" aria-label="' + esc((T.cart_add || '') + ': ' + p.t + (p.vt ? ' (' + p.vt + ')' : '')) + '">' + esc(T.cart_add) + '</button>' +
      '<p class="mwq-toy__ok" data-cart-ok hidden tabindex="-1">' + IC.check + '<span>' + esc(T.cart_added) + '</span><a href="' + esc(cartRoot() + 'cart') + '">' + esc(T.cart_view) + '</a></p><p class="mwq-toy__err" data-cart-err role="alert" hidden></p></div>' : '';
    return '<li class="mwq-toy">' + (p.i ? '<span class="mwq-toy__img"><img src="' + esc(p.i) + '" srcset="' + esc(p.i) + ' 240w, ' + esc(i2) + ' 480w" sizes="72px" alt="" width="240" height="240" loading="lazy" decoding="async"></span>' : '<span class="mwq-toy__img"></span>') +
      '<div class="mwq-toy__t"><a class="mwq-toy__a" href="' + esc(safeUrl(p.u)) + '">' + esc(p.t) + '</a><span class="mwq-toy__p">' + esc(priceOf(p)) + (p.vt ? ' <span class="mwq-toy__vt">· ' + esc(p.vt) + '</span>' : '') + '</span>' +
      (p.al ? '<span class="mwq-toy__age">' + IC.tag + esc((T.age_label ? T.age_label + ' ' : '') + p.al) + '</span>' : '') +
      '<p class="mwq-toy__why">' + nobr(whyText(o, ans)) + '</p>' + cart + '</div></li>';
  }
  function chips(ans) {
    var L = D.labels || {}, out = [], fl = areas(ans);
    if (ans.who === 'gift' && L.who) out.push(L.who.gift);
    if (fl.length && BANDS[ans.age].focus.length) out.push(fl.map(function (f) { return (L.fshort && L.fshort[f]) || (L.focus && L.focus[f]) || f; }).join(' · '));
    if (out.length < 2 && ans.loves.length && L.loves) out.push(L.loves[ans.loves[0]]);
    if (out.length < 2 && ans.home.length && L.home) out.push(L.home[ans.home[0]]);
    return out.filter(Boolean).slice(0, 2);
  }
  /* the personal summary (round 5): "Your 12–18 month old: focus on hands and words" + 3 activities + 1 watch-for line;
     gift: "A gift for a 12–18 month old: good for hands and words" + 3 milestones + the AAP line */
  function sumHead(m) {
    var b = m.band, ans = m.ans, L = D.labels || {}, fl = areas(ans);
    var who = m.gift ? b.sumg : b.sum; if (!who) return '';
    var f = '';
    if (BANDS[ans.age].focus.length) f = fl.length ? String((m.gift ? T.g_sum_focus : T.sum_focus) || '').replace('[focus]', names(fl, L.fshort, true)) : (m.gift ? '' : (T.sum_all || ''));
    return who + (f ? ': ' + f : '');
  }
  function sumHtml(m) {
    var h = sumHead(m); if (!h) return '';
    var lab = function (t) { return t ? '<p class="mwq-sum__lab">' + esc(t) + '</p>' : ''; }, body;
    if (m.gift) body = lab(T.g_sum_work) + pts(m.working.slice(0, 3).map(function (x) { return esc(x.short) + marker(x.age); })) + (T.g_sum_look_text ? lab(T.g_sum_look) + '<p class="mwq-sum__watch">' + IC.heart + '<span>' + esc(T.g_sum_look_text) + '</span></p>' : '');
    else body = lab(m.band.sumt || T.sum_try) + pts(m.tries.slice(0, 3).map(function (x) { return esc(x.short); })) + (m.watch[0] ? lab(T.sum_watch) + '<p class="mwq-sum__watch">' + IC.shield + '<span>' + esc(m.watch[0].short) + '</span></p>' : '');
    return '<section class="mwq-card mwq-sum" aria-labelledby="mwq-r-sum"><h3 class="mwq-sum__h" id="mwq-r-sum">' + esc(h) + '</h3>' + body + '</section>';
  }
  function render(m) {
    texts();
    var b = m.band, ans = m.ans, id = 'mwq-r', h = [];
    var ch = chips(ans);
    h.push('<header class="mwq-res__head">' + (b.pic ? '<span class="mwq-res__pic"><img src="' + esc(b.pic) + '" alt="" width="150" height="150" decoding="async"></span>' : '<span class="mwq-res__pic mwq-res__pic--icon">' + IC.heart + '</span>') +
      '<h2 class="mwq-res__h" id="' + id + '-h" tabindex="-1">' + esc(m.gift ? b.gift : b.title) + '</h2>' +
      (ch.length ? '<ul class="mwq-chips" role="list">' + ch.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul>' : '') +
      '<div class="mwq-res__acts"><button type="button" class="mwq-btn mwq-btn--ghost mwq-btn--sm" data-act="edit">' + IC.edit + '<span>' + esc(T.edit) + '</span></button>' +
      '<button type="button" class="mwq-btn mwq-btn--soft mwq-btn--sm" data-act="share">' + IC.link + '<span>' + esc(T.share) + '</span></button></div>' +
      (m.gift && T.g_pass ? '<p class="mwq-res__note" data-share-note>' + esc(T.g_pass) + '</p>' : '<p class="mwq-res__note" data-share-note hidden></p>') + '</header>');
    var cWork = card({ id: id + '-w', icon: IC.grow, title: m.gift ? T.g_working : (b.wh || T.h_working),
      points: m.working.slice(0, 3).map(function (x) { return esc(x.short) + marker(x.age); }),
      more: (T.working_note ? '<p class="mwq-note">' + esc(T.working_note) + '</p>' : '') + fullList(m.working, '', function (x) { return esc(x.text) + marker(x.age); }) });
    var tTry = m.gift ? T.g_idea : T.h_try;
    var cTry = card({ id: id + '-t', icon: IC.star, cls: 'mwq-card--gold', title: tTry, badge: /\bfree\b/i.test(String(tTry || '')) ? '' : T.free, sub: m.gift ? '' : T.try_sub,
      points: m.tries.slice(0, m.gift ? 1 : 3).map(function (x) { return esc(x.short); }),
      more: fullList(m.tries.slice(0, m.gift ? 1 : 6), 'mwq-full--num', function (x) { return esc(x.text); }) + (!m.gift && T.habit ? '<p class="mwq-habit">' + IC.heart + '<span>' + esc(T.habit) + '</span></p>' : '') });
    var cSetup = m.setup.length ? card({ id: id + '-s', icon: IC.shelf, cls: 'mwq-card--sage', title: T.h_setup,
      points: m.setup.slice(0, 3).map(function (x) { return esc(x.short); }),
      more: fullList(m.setup, '', function (x) { return esc(x.text); }) }) : '';
    var doc = m.common.filter(function (x) { return has(x.tags, 'doctor'); })[0];
    var cWatch = m.watch.length ? card({ id: id + '-x', icon: IC.shield, cls: 'mwq-card--sage', title: T.h_watch, sub: T.watch_sub,
      points: m.watch.slice(0, 2).map(function (x) { return esc(x.short); }).concat(doc ? ['<strong>' + esc(doc.short) + '</strong>'] : []),
      more: fullList(m.watch, '', function (x) { return esc(x.text); }) + fullList(m.common, 'mwq-full--soft', function (x) { return esc(x.text) + (x.lt && x.lu ? ' <a href="' + esc(safeUrl(x.lu)) + '">' + esc(x.lt) + '</a>' : ''); }) }) : '';
    var toysBody;
    if (m.toys === null) toysBody = '<p class="mwq-empty">' + esc(T.toys_error) + '</p>';
    else if (!m.toys.length) toysBody = '<p class="mwq-empty">' + esc(T.toys_empty) + '</p>';
    else toysBody = '<ul class="mwq-toys" role="list">' + m.toys.map(function (o) { return toyRow(o, ans); }).join('') + '</ul>';
    var cToys = card({ id: id + '-y', icon: IC.toys, title: m.gift ? T.g_toys : T.h_toys, body: toysBody + (m.gift && T.g_notes ? '<p class="mwq-note">' + esc(T.g_notes) + '</p>' : ''),
      more: (T.toys_note ? '<p class="mwq-note">' + esc(T.toys_note) + '</p>' : '') + (T.toys_rules ? '<p class="mwq-note">' + esc(T.toys_rules) + '</p>' : '') +
        (b.more && b.more.u && b.more.t ? '<p><a class="mwq-link" href="' + esc(safeUrl(b.more.u)) + '">' + esc(b.more.t) + '</a></p>' : '') });
    var cRead = card({ id: id + '-rd', icon: IC.book, title: T.h_read, body: '<div data-read-slot></div>',
      more: b.read.length ? fullList(b.read, 'mwq-full--links', function (x) { return '<a href="' + esc(safeUrl(x.u)) + '">' + esc(x.t) + '</a>'; }) : '' });
    h.push('<div class="mwq-cards">' + sumHtml(m) + (m.gift ? cWork + cToys + cTry + cRead : cWork + cTry + cSetup + cWatch + cToys + cRead) + '</div>');
    return h.join('');
  }
  function sourcesHtml(m) {
    var b = m.band;
    return '<details class="mwq-src"><summary>' + esc(T.sources_label) + '</summary><div class="mwq-src__in"><p>' +
      b.sources.map(function (x) { return x.u ? '<a href="' + esc(safeUrl(x.u)) + '">' + esc(x.t) + '</a>' : esc(x.t); }).join(', ') + '.</p>' +
      (T.suggestion_note ? '<p>' + esc(T.suggestion_note) + '</p>' : '') + (T.answers_note ? '<p>' + esc(T.answers_note) + '</p>' : '') + '</div></details>';
  }

  /* ---------------- state + quiz view ---------------- */
  var state = { age: null, who: null, focus: [], loves: [], home: [] };
  var steps = S5, at = 0, movingTo = null, started = false, opener = null, current = null, showing = false, finished = false;
  function stepsFor(age) { return (BANDS[age] && BANDS[age].steps) || S5; }
  function picks() { return (state.focus || []).filter(function (x) { return x !== 'all'; }); }
  function syncStep(name) {
    var el = STEP[name], B = BANDS[state.age], full = name === 'focus' && picks().length >= MAX_FOCUS;
    [].forEach.call(el.querySelectorAll('[data-v]'), function (b) {
      var v = b.getAttribute('data-v');
      var ok = name === 'focus' ? (!B || has(B.focus, v)) : name === 'loves' ? (!B || has(B.loves, v)) : true;
      var on = name === 'focus' || name === 'loves' ? has(state[name] || [], v) : state[name] === v;
      b.hidden = !ok;
      b.setAttribute('aria-pressed', String(on));
      if (name === 'focus') { if (full && !on && v !== 'all') b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); }
    });
    [].forEach.call(el.querySelectorAll('input[type="checkbox"]'), function (c) {
      var v = c.value;
      c.checked = has(state[name] || [], v) || (name === 'home' && v === 'none' && !!state.homeNone);
    });
    var grid = el.querySelector('.mwq-grid');
    if (grid) { var vis = [].filter.call(grid.children, function (o) { o.classList.remove('is-wide'); return !o.hidden; }); if (vis.length % 2) vis[vis.length - 1].classList.add('is-wide'); }
  }
  function footLabel() {
    var name = steps[at], last = at === steps.length - 1;
    var picked = name === 'focus' ? (state.focus || []).length : name === 'loves' ? state.loves.length : (state.home.length || state.homeNone ? 1 : 0);
    nextBtn.querySelector('span').textContent = last ? T.finish || 'See my results' : (picked ? T.next : T.skip);
    if (!pickEl) return;
    pickEl.hidden = name !== 'focus';
    if (name !== 'focus') return;
    var n = picks().length;
    pickN.textContent = has(state.focus || [], 'all') ? '' : String(T.pick_count || '[n] of 3').replace('[n]', n);
    pickN.hidden = n >= MAX_FOCUS && !!pickFull;
    if (pickFull) pickFull.hidden = n < MAX_FOCUS;
  }
  function clearConfirm() {
    [].forEach.call(dlg.querySelectorAll('.is-confirm'), function (t) { t.classList.remove('is-confirm'); });
    Object.keys(STEP).forEach(function (k) { STEP[k].classList.remove('is-confirming'); });
  }
  function hideSteps() {
    clearConfirm();
    Object.keys(STEP).forEach(function (k) { STEP[k].hidden = true; STEP[k].classList.remove('is-fwd', 'is-back'); });
    foot.hidden = true; dlg.classList.remove('has-foot');
    if (resumeEl) resumeEl.hidden = true;
  }
  function pct(i) { return Math.round((Math.min(i + 1, steps.length) / steps.length) * 100); }
  function setBar(i) { if (bar) { bar.style.transition = ''; bar.style.width = pct(i) + '%'; } }
  /* the only progress line: on the thinking screen the top bar fills toward the next step for the time on screen */
  function barTo(i, ms) {
    if (!bar) return;
    var to = pct(i);
    if (reduce) { var from = parseFloat(bar.style.width) || 0; [1, 2, 3, 4].forEach(function (k) { later(function () { bar.style.width = (from + (to - from) * k / 4) + '%'; }, Math.max(0, Math.round(ms * k / 4) - 250)); }); return; }
    bar.style.transition = 'width ' + ms + 'ms linear'; void bar.offsetWidth; bar.style.width = to + '%';
  }
  function whoTitles() { var g = state.who === 'gift'; [].forEach.call(dlg.querySelectorAll('[data-who]'), function (el) { el.hidden = el.getAttribute('data-who') !== (g ? 'gift' : 'me'); }); }
  function showStep(i, dir) {
    texts();
    stopMoment(); clearConfirm();
    if (thinkEl) thinkEl.hidden = true;
    if (resumeEl) resumeEl.hidden = true;
    steps = stepsFor(state.age);
    at = Math.max(0, Math.min(i, steps.length - 1)); movingTo = null;
    var name = steps[at];
    Object.keys(STEP).forEach(function (k) { STEP[k].hidden = k !== name; STEP[k].classList.remove('is-fwd', 'is-back'); });
    syncStep(name); whoTitles();
    var cnt = String(T.progress || '[n] of [total]').replace('[n]', at + 1).replace('[total]', steps.length);
    [].forEach.call(dlg.querySelectorAll('[data-count]'), function (c) { c.textContent = cnt; });
    setBar(at);
    backBtn.style.visibility = at === 0 ? 'hidden' : 'visible';
    var multi = name === 'focus' || name === 'loves' || name === 'home';
    foot.hidden = !multi; dlg.classList.toggle('has-foot', multi);
    if (multi) footLabel();
    var el = STEP[name];
    if (!reduce && dir) { void el.offsetWidth; el.classList.add(dir === 'back' ? 'is-back' : 'is-fwd'); }
    if (bodyEl) bodyEl.scrollTop = 0;
    var hq = el.querySelector('.mwq-step__h'); if (hq) hq.focus({ preventScroll: true });
  }

  /* ---------------- moments between questions (round 5) ----------------
     After the AGE: the thinking screen (drawing, one line, one CDC milestone tip), WAIT_MS to WAIT_MAX by text length, a small
     Continue after GO_MS, the top bar filling toward the next step. After the other answers: the picked tiles get a check and
     a pulse for CONFIRM_MS, then the next question slides in. Same text and time with reduced motion (no animation). */
  var WAIT_MS = 4500, WAIT_MAX = 7000, GO_MS = 3000, STEP_MS = 1150, CONFIRM_MS = 1000, timers = [], mid = 0, running = false, goNext = null;
  function later(fn, ms) { var id = mid; timers.push(setTimeout(function () { if (id === mid) fn(); }, ms)); }
  function stopMoment() { var was = running; timers.forEach(clearTimeout); timers = []; mid++; running = false; goNext = null; return was; }
  function say(t) { if (!appLive || !t) return; appLive.textContent = ''; setTimeout(function () { appLive.textContent = t; }, 60); }
  function sayPage(t) { if (!live || !t) return; live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); }
  function ageLine() { return (D.b && D.b[state.age] && D.b[state.age].think) || ''; }
  function ageTip() { var b = state.age && band(state.age); var w = b && b.working[0]; return w ? String(T.tip_age || '').replace('[milestone]', w.short).replace('[age]', w.age) : ''; }
  function agePic() { var im = dlg.querySelector('[data-q="age"] [data-v="' + state.age + '"] img'); return im ? (im.currentSrc || im.src || '') : ''; }
  function setPic(el, src) {
    if (!el) return;
    if (src) { el.classList.remove('is-icon'); el.innerHTML = '<img src="' + esc(src) + '" alt="" width="160" height="160" decoding="async">'; }
    else { el.classList.add('is-icon'); el.innerHTML = IC.heart; }
  }
  function wordCount(s) { return String(s || '').split(/\s+/).filter(Boolean).length; }
  /* keep a hyphenated word or a range on one line ("in-and-out", "2-year-olds", "12–18"); the text itself stays the same */
  function nobr(s) { return esc(s).replace(/\S*[-–]\S*/g, function (w) { return '<span style="white-space:nowrap">' + w + '</span>'; }); }
  function waitScreen(nx, then) {
    stopMoment(); running = true; movingTo = nx;
    var line = ageLine();
    if (!thinkEl || !line) { running = false; then(); return; }
    hideSteps();
    var tip = '', pic = '';
    try { tip = ageTip(); pic = agePic(); } catch (e) { tip = tip || ''; }
    var ms = Math.max(WAIT_MS, Math.min(WAIT_MAX, 1000 + 250 * (wordCount(line) + wordCount(tip))));
    thinkEl.hidden = false; buildEl.hidden = true; waitEl.hidden = false;
    waitH.innerHTML = nobr(line);
    setPic(waitPic, pic);
    tipText.innerHTML = nobr(tip); tipBox.hidden = !tip;
    goBtn.hidden = true; goBtn.classList.remove('is-in');
    waitEl.classList.remove('is-in'); void waitEl.offsetWidth; waitEl.classList.add('is-in');
    barTo(nx, ms);
    waitH.focus({ preventScroll: true });
    if (tip) say((T.tip_label ? T.tip_label + ': ' : '') + tip);
    var done = function () { if (!running) return; running = false; goNext = null; then(); };
    goNext = done;
    later(function () { goBtn.hidden = false; goBtn.classList.add('is-in'); }, GO_MS);
    later(done, ms);
  }
  function confirmMoment(name, nx, then) {
    stopMoment(); running = true; movingTo = nx;
    var el = STEP[name];
    var on = el ? [].filter.call(el.querySelectorAll('.mwq-tile[aria-pressed="true"]'), function (t) { return !t.hidden; }) : [];
    setBar(nx);
    if (!on.length) { running = false; then(); return; }   /* nothing picked (Skip): nothing to confirm */
    el.classList.add('is-confirming');
    on.forEach(function (t) { t.classList.remove('is-confirm'); void t.offsetWidth; t.classList.add('is-confirm'); });
    later(function () { running = false; clearConfirm(); then(); }, CONFIRM_MS);
  }
  function buildSteps(a) {
    var L = D.labels || {}, fl = areas(a), out = [];
    out.push({ t: String(T.build_milestones || '').replace('[age]', ageWords(a.age)) });
    if (a.who === 'gift') { out.push({ t: T.build_toys, wait: true }); out.push({ t: T.build_gift }); }
    else {
      out.push({ t: fl.length ? String(T.build_activities || '').replace('[focus]', names(fl, L.fshort, true)) : T.build_activities_all });
      out.push({ t: T.build_space });
      out.push({ t: T.build_toys, wait: true });
    }
    return out.filter(function (s) { return s.t; });
  }
  function runBuild(a, then) {
    stopMoment(); running = true; movingTo = steps.length;
    if (!thinkEl) { running = false; then(); return; }
    hideSteps();
    var list = buildSteps(a), per = Math.max(STEP_MS, Math.round(4400 / list.length)), i = 0, idxP = loadIndex().then(function () {}, function () {});
    thinkEl.hidden = false; waitEl.hidden = true; buildEl.hidden = false;
    var bh = a.who === 'gift' ? T.build_h_gift : T.build_h; if (bh) buildH.textContent = bh;
    setPic(buildPic, agePic());
    buildList.innerHTML = list.map(function (s) { return '<li class="mwq-build__s"><span class="mwq-build__ic" aria-hidden="true"></span><span>' + nobr(s.t) + '</span></li>'; }).join('');
    var lis = buildList.children;
    buildEl.classList.remove('is-in'); void buildEl.offsetWidth; buildEl.classList.add('is-in');
    buildH.focus({ preventScroll: true });
    var id = mid;
    function step() {
      if (i > 0) lis[i - 1].className = 'mwq-build__s is-done';
      if (i >= lis.length) { later(function () { running = false; then(); }, 600); return; }
      var cur = i++;
      lis[cur].className = 'mwq-build__s is-on';
      later(function () { say(list[cur].t); }, 80);
      if (list[cur].wait) { var t0 = Date.now(); idxP.then(function () { if (id === mid) later(step, Math.max(0, per - (Date.now() - t0))); }); }
      else later(step, per);
    }
    step();
  }

  /* ---------------- keep the answers when the quiz is closed before the end (round 5) ---------------- */
  var PKEY = 'mwq-progress', saved = null;
  function saveProgress() {
    if (finished || !state.age) return;
    var pos = movingTo !== null ? movingTo : at;
    if (pos < 1) return;   /* nothing answered yet on this run */
    saved = { s: { age: state.age, who: state.who, focus: (state.focus || []).slice(), loves: (state.loves || []).slice(), home: (state.home || []).slice(), homeNone: !!state.homeNone }, at: pos };
    try { sessionStorage.setItem(PKEY, JSON.stringify(saved)); } catch (e) {}
  }
  function loadProgress() {
    if (saved) return saved;
    try { var x = JSON.parse(sessionStorage.getItem(PKEY) || 'null'); if (x && x.s && BANDS[x.s.age] && typeof x.at === 'number') saved = x; } catch (e) {}
    return saved;
  }
  function clearProgress() { saved = null; try { sessionStorage.removeItem(PKEY); } catch (e) {} }
  function showResume(sp) {
    hideSteps(); stopMoment();
    if (thinkEl) thinkEl.hidden = true;
    var st = stepsFor(sp.s.age), n = Math.min(sp.at, st.length);
    var t = resumeEl.querySelector('[data-resume-t]');
    if (t) t.textContent = String(T.resume_text || '').replace('[n]', n).replace('[total]', st.length);
    var im = dlg.querySelector('[data-q="age"] [data-v="' + sp.s.age + '"] img');
    setPic(resumeEl.querySelector('[data-resume-pic]'), im ? (im.currentSrc || im.src || '') : '');
    if (bar) { bar.style.transition = ''; bar.style.width = Math.round((n / st.length) * 100) + '%'; }
    backBtn.style.visibility = 'hidden';
    resumeEl.hidden = false;
    resumeEl.classList.remove('is-in'); void resumeEl.offsetWidth; resumeEl.classList.add('is-in');
    var h = resumeEl.querySelector('.mwq-resume__h'); if (h) h.focus({ preventScroll: true });
  }
  function resumeGo() {
    var sp = loadProgress(); if (!sp) { resumeNew(); return; }
    state = { age: sp.s.age, who: sp.s.who, focus: sp.s.focus || [], loves: sp.s.loves || [], home: sp.s.home || [], homeNone: !!sp.s.homeNone };
    steps = stepsFor(state.age);
    var k = Math.max(0, Math.min(sp.at, steps.length - 1));
    clearProgress();
    try { history.replaceState({ mwq: 0, k: KEY }, ''); for (var i = 1; i <= k; i++) history.pushState({ mwq: i, k: KEY }, ''); } catch (e) {}
    showStep(k, 'fwd');
  }
  function resumeNew() {
    clearProgress();
    state = { age: null, who: null, focus: [], loves: [], home: [] };
    try { history.replaceState({ mwq: 0, k: KEY }, ''); } catch (e) {}
    showStep(0, 'fwd');
  }

  function openDialogOnly() {
    if (dlg.open) return;
    try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    document.documentElement.classList.add('mwq-open');
  }
  function closeDialog() {
    if (!dlg.open) return;
    try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
    document.documentElement.classList.remove('mwq-open');
  }
  function pushStep(i, dir) { try { history.pushState({ mwq: i, k: KEY }, ''); } catch (e) {} showStep(i, dir || 'fwd'); }
  function prepOpen(from) {
    opener = from || startBtn; finished = false;
    texts();
    loadIndex().catch(function () {});
    [].forEach.call(dlg.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
    openDialogOnly();
  }
  function openQuiz(from) { prepOpen(from); pushStep(0, null); }
  function startQuiz() {
    var sp = loadProgress();
    if (sp && resumeEl) { prepOpen(startBtn); try { history.pushState({ mwq: 0, k: KEY }, ''); } catch (e) {} showResume(sp); return; }
    openQuiz(startBtn);
  }
  function closeQuiz() {
    if (resumeEl && resumeEl.hidden) saveProgress();
    stopMoment();
    var st = history.state || {}, n = typeof st.mwq === 'number' ? st.mwq + 1 : (st.mwqb ? steps.length + 1 : 0);
    if (n) { try { history.go(-n); } catch (e) {} }
    setTimeout(function () { if (dlg.open) { closeDialog(); restoreFocus(); } }, 600);
  }
  function restoreFocus() {
    var t = showing ? resWrap.querySelector('[data-act="edit"]') : startBtn;
    if (opener && document.contains(opener) && opener.offsetParent !== null) t = opener;
    if (t) t.focus();
  }
  /* GA4 (owner 2026-10-11, "show quiz use in Google Analytics"): the store's Google tag already runs on the page (window.gtag
     with G-Y38VJT3KJE), so each quiz event also goes to GA4 in the visitor's own session: quiz_start, quiz_complete and
     quiz_email, with age_band, plan_for and quiz_focus (registered as custom dimensions in GA4). No gtag = nothing sent. */
  var GA4_ID = 'G-Y38VJT3KJE';
  function publish(name, payload) {
    try { var S = window.Shopify; if (S && S.analytics && typeof S.analytics.publish === 'function') { var r = S.analytics.publish(name, payload); if (r && typeof r.catch === 'function') r.catch(function () {}); } } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name.replace(/^mirthwell:/, ''), { send_to: GA4_ID, age_band: payload.band || '', plan_for: payload.plan_for || '', quiz_focus: payload.focus || '' }); } catch (e) {}
  }
  /* Quiz results sheet (owner 2026-10-17, "record everything in a sheets file"): one row per FINISHED quiz goes to the
     "Quiz results" Google Sheet through its Apps Script web app (section setting sheet_url; empty = nothing is sent). The row
     holds the answers (as the page shows them), the toys shown, device, where the visitor came from and the UTM campaign;
     never the email address (that stays in Klaviyo). When the plan email is sent, a second post turns the row's "Email given"
     to yes (matched by qid). Sent with mode no-cors + keepalive: fire and forget, no reply is read, nothing can throw, no
     effect on page speed. Rows from the theme editor / other templates are marked "preview", from test browsers
     (navigator.webdriver) "robot", from a URL with mwtest=1 "test". Shared result links (no quiz run) are not logged, the same
     as GA4 quiz_complete. */
  var SHEET_KEY = 'mwq1', sheetQid = '';
  function sheetTest() {
    try {
      if (root.getAttribute('data-preview') !== 'false') return 'preview';
      if (navigator.webdriver) return 'robot';
      if (/[?&]mwtest=1(?:&|$)/.test(location.search)) return 'test';
    } catch (e) {}
    return '';
  }
  function sheetSend(row) {
    if (!SHEET || !/^https:\/\/script\.google\.com\//.test(SHEET)) return;
    row.k = SHEET_KEY;
    try { fetch(SHEET, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(row) }).catch(function () {}); } catch (e) {}
  }
  function sheetRow(m) {
    var ans = m.ans, L = D.labels || {}, b = m.band || {};
    var lab = function (map, k) { return (map && map[k]) || k; };
    var utm = {};
    try { location.search.replace(/[?&](utm_[a-z]+)=([^&#]*)/g, function (_, k, v) { utm[k] = decodeURIComponent(v.replace(/\+/g, ' ')); }); } catch (e) {}
    var from = '';
    try { var ref = document.referrer ? new URL(document.referrer) : null; from = ref ? (ref.host === location.host ? ref.pathname : ref.host + ref.pathname) : ''; } catch (e) {}
    sheetQid = 'q' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    return {
      qid: sheetQid, test: sheetTest(),
      age: b.label || ans.age, who: lab(L.who, ans.who),
      focus: ans.focus.map(function (k) { return lab(L.focus, k); }).join(', '),
      loves: ans.loves.map(function (k) { return lab(L.loves, k); }).join(', '),
      home: ans.home.map(function (k) { return lab(L.home, k); }).join(', '),
      codes: [ans.age, ans.who, ans.focus.join('+'), ans.loves.join('+'), ans.home.join('+')].join(' | '),
      toys: (m.toys || []).map(function (o) { return o.p.t + (o.p.vt ? ' (' + o.p.vt + ')' : ''); }).join(' | '),
      device: window.innerWidth < 768 ? 'phone' : 'computer',
      from: from, utm: [utm.utm_source, utm.utm_medium, utm.utm_campaign].filter(Boolean).join(' / '),
      page: location.pathname
    };
  }
  function choose(q, v) {
    state[q] = v;
    if (q === 'age') {
      var B = BANDS[v] || { focus: [], loves: [] };
      state.focus = (state.focus || []).filter(function (x) { return has(B.focus, x); });
      state.loves = (state.loves || []).filter(function (x) { return has(B.loves, x); });
      if (!started) { started = true; publish('mirthwell:quiz_start', { band: v, focus: '' }); }
    }
    syncStep(q);
    advance();
  }
  function flashFull() {
    if (!pickFull) return;
    pickFull.hidden = false;
    pickFull.classList.remove('is-flash'); void pickFull.offsetWidth; pickFull.classList.add('is-flash');
    say(pickFull.textContent);
  }
  function toggleFocus(v) {
    var B = BANDS[state.age] || { focus: [] };
    var cur = (state.focus || []).filter(function (x) { return has(B.focus, x); });
    if (v === 'all') cur = has(cur, 'all') ? [] : ['all'];
    else if (has(cur, v)) cur = cur.filter(function (x) { return x !== v; });
    else {
      cur = cur.filter(function (x) { return x !== 'all'; });
      if (cur.length >= MAX_FOCUS) { flashFull(); return; }
      cur.push(v);
    }
    state.focus = cur;
    syncStep('focus'); footLabel();
  }
  function toggleLove(v) {
    var B = BANDS[state.age] || { loves: [] };
    var cur = (state.loves || []).filter(function (x) { return has(B.loves, x); });
    state.loves = has(cur, v) ? cur.filter(function (x) { return x !== v; }) : cur.concat([v]);
    syncStep('loves'); footLabel();
  }
  function advance() {
    var name = steps[at];
    if (at >= steps.length - 1) { finish(false); return; }
    var nx = at + 1;
    try { history.pushState({ mwq: nx, k: KEY }, ''); } catch (e) {}
    backBtn.style.visibility = 'visible';
    var go = function () { showStep(nx, 'fwd'); };
    if (name === 'age') waitScreen(nx, go); else confirmMoment(name, nx, go);
  }
  var QKEYS = ['age', 'for', 'focus', 'loves', 'home', 'customer_posted'];
  function urlFor(a) {
    var keep = location.search.replace(/^\?/, '').split('&').filter(function (kv) { return kv && !has(QKEYS, decodeURIComponent(kv.split('=')[0])); });
    var q = [];
    if (a) {
      q.push('age=' + encodeURIComponent(a.age));
      if (a.who === 'gift') q.push('for=gift');
      if (areas(a).length) q.push('focus=' + areas(a).map(encodeURIComponent).join(','));
      if (a.loves.length) q.push('loves=' + a.loves.map(encodeURIComponent).join(','));
      if (a.home.length) q.push('home=' + a.home.map(encodeURIComponent).join(','));
    }
    var s = keep.concat(q).join('&');
    return location.pathname + (s ? '?' + s : '');
  }
  function readUrl() {
    var p; try { p = new URLSearchParams(location.search); } catch (e) { return null; }
    if (!p.get('age')) return null;
    var list = function (k) { return String(p.get(k) || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
    return normalize({ age: p.get('age'), who: p.get('for'), focus: list('focus'), loves: list('loves'), home: list('home') });
  }
  function finish(fromPop) {
    var a = normalize(state); if (!a) return;
    if (!fromPop) { try { history.pushState({ mwqb: 1, k: KEY }, ''); } catch (e) {} }
    if (bar) { bar.style.transition = ''; bar.style.width = '100%'; }
    backBtn.style.visibility = 'visible';
    runBuild(a, function () {
      finished = true; clearProgress();
      try { history.replaceState({ mwqr: 1, k: KEY }, '', urlFor(a)); } catch (e) {}
      closeDialog();
      showResult(a, true);
    });
  }
  function showStart() {
    showing = false; current = null;
    document.documentElement.classList.remove('mwq-r-pending');
    root.classList.remove('mwq--result');
    resWrap.innerHTML = ''; if (mail) mail.hidden = true;
  }
  /* scroll so a target sits below the theme's fixed or sticky header (it can turn fixed only after the page scrolls) */
  function coverAt(y) {
    var els = document.elementsFromPoint ? document.elementsFromPoint(window.innerWidth / 2, y) : [], best = 0;
    for (var i = 0; i < els.length; i++) {
      for (var n = els[i]; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
        var pos = getComputedStyle(n).position;
        if (pos === 'fixed' || pos === 'sticky') { var r = n.getBoundingClientRect(); if (r.top <= y + 1 && r.height < window.innerHeight / 2) best = Math.max(best, r.bottom); break; }
      }
    }
    return best;
  }
  function topCover() { var c = 0; for (var g = 0; g < 4; g++) { var nb = coverAt(c + 1); if (nb <= c + 0.5) break; c = nb; } return Math.round(c); }
  function scrollToEl(el, smooth) {
    if (el.getBoundingClientRect().top + window.pageYOffset < window.innerHeight * 0.5) { window.scrollTo(0, 0); return; }
    var go = function (beh) { window.scrollTo({ top: Math.max(0, Math.round(el.getBoundingClientRect().top + window.pageYOffset - topCover() - 12)), behavior: beh }); };
    go(smooth && !reduce ? 'smooth' : 'auto');
    if (!smooth) setTimeout(function () { go('auto'); }, 400);
  }
  function resetMail(gift) {
    if (!mail) return;
    [].forEach.call(mail.querySelectorAll('[data-for]'), function (el) { el.hidden = el.getAttribute('data-for') !== (gift ? 'gift' : 'me'); });
    mail.classList.remove('is-sent');
    var ok = mail.querySelector('[data-mail-ok]'), er = mail.querySelector('[data-mail-err]'), inp = mail.querySelector('input[type="email"]');
    if (ok) { ok.hidden = true; ok.textContent = ''; }
    if (er) { er.hidden = true; er.textContent = ''; }
    if (inp) inp.removeAttribute('aria-invalid');
    mailUid = '';
  }
  function showResult(a, fromQuiz) {
    texts();
    showing = true;
    root.classList.add('mwq--result');
    resWrap.setAttribute('aria-busy', 'true');
    if (!resWrap.firstChild) resWrap.innerHTML = '<p class="mwq-loading">' + esc(T.loading) + '</p>';
    var done = function () {
      var m = compute(a); if (!m) { showStart(); return; }
      current = m;
      state = { age: m.ans.age, who: m.ans.who, focus: m.ans.focus.slice(), loves: m.ans.loves.slice(), home: m.ans.home.slice() };
      resWrap.innerHTML = render(m) + sourcesHtml(m);
      resWrap.removeAttribute('aria-busy');
      var tpl = root.querySelector('[data-read-static]'), slot = resWrap.querySelector('[data-read-slot]');
      if (tpl && slot && tpl.content) { slot.appendChild(tpl.content.cloneNode(true)); var gp = slot.querySelector('[data-guide-pages]'); if (gp) gp.textContent = String(gp.getAttribute('data-text') || '').replace('[pages]', m.band.gp || ''); }
      if (mail) {
        resetMail(m.gift);
        mail.hidden = false;
        var src = resWrap.querySelector('.mwq-src'); if (src) mail.parentNode.insertBefore(src, mail.nextSibling);
      }
      document.documentElement.classList.remove('mwq-r-pending');
      if (fromQuiz) {
        publish('mirthwell:quiz_complete', { band: m.ans.age, focus: m.ans.focus.join(','), plan_for: m.gift ? 'gift' : 'me' });
        sheetSend(sheetRow(m));
        scrollToEl(resWrap, false);
        var hh = resWrap.querySelector('.mwq-res__h'); if (hh) hh.focus({ preventScroll: true });
        if (live) { live.textContent = ''; setTimeout(function () { live.textContent = (T.live || '') + ' ' + (m.gift ? m.band.gift : m.band.title); }, 80); }
      }
    };
    return loadIndex().then(done, function () { PRODUCTS = null; done(); });
  }

  /* ---------------- add to cart (round 5): Shopify Ajax cart, the in-stock default variant ---------------- */
  function addToCart(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = Number(btn.getAttribute('data-cart')), box = btn.closest('.mwq-toy__cart'); if (!id || !box) return;
    var ok = box.querySelector('[data-cart-ok]'), er = box.querySelector('[data-cart-err]'), title = btn.getAttribute('data-title') || '';
    btn.setAttribute('aria-busy', 'true'); btn.textContent = T.cart_adding || T.cart_add || '';
    if (er) { er.hidden = true; er.textContent = ''; }
    fetch(cartRoot() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || (j && j.status && j.status !== 200)) throw new Error('cart ' + r.status); return j; }); })
      .then(function () {
        btn.hidden = true; btn.removeAttribute('aria-busy');
        if (ok) { ok.hidden = false; ok.focus({ preventScroll: true }); }
        sayPage(String(T.cart_sr || '').replace('[title]', title));
        try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
      })
      .catch(function () {
        btn.removeAttribute('aria-busy'); btn.textContent = T.cart_add || '';
        if (er) { er.textContent = T.cart_error || ''; er.hidden = false; }
      });
  }

  /* ---------------- "Email me my plan" (round 5): Klaviyo client API, live page only ---------------- */
  var KREV = '2026-07-15', KBASE = 'https://a.klaviyo.com/client/', mailBusy = false, mailUid = '';
  function absUrl(u) { u = String(u || ''); if (!u) return ''; if (/^https?:\/\//i.test(u)) return u; if (u.indexOf('//') === 0) return 'https:' + u; return location.origin + (u.charAt(0) === '/' ? u : '/' + u); }
  function kpost(path, body) {
    return fetch(KBASE + path + '?company_id=' + encodeURIComponent(MAIL.company || ''), { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: KREV }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return r; });
  }
  function planProps(m) {
    var b = m.band, ans = m.ans, L = D.labels || {}, fl = areas(ans);
    return {
      plan_for: m.gift ? 'gift' : 'me', age_band: ans.age, age_label: b.label, title: m.gift ? b.gift : b.title, summary: sumHead(m),
      focus: fl.map(function (f) { return (L.focus && L.focus[f]) || f; }), focus_text: fl.length ? names(fl, L.fshort, true) : '',
      activities: m.tries.slice(0, 3).map(function (x) { return x.short; }),
      milestones: m.working.slice(0, 3).map(function (x) { return { text: x.short, age: x.age }; }),
      setup: (m.setup || []).slice(0, 3).map(function (x) { return x.short; }),
      watch: m.watch[0] ? m.watch[0].short : '',
      toys: (m.toys || []).map(function (o) { var p = o.p; return { title: p.t, url: absUrl(p.u), image: absUrl(p.i ? String(p.i).replace(/([?&](?:width|height)=)240\b/g, '$1480') : ''), price: priceOf(p), option: p.vt || '' }; }),
      small_parts: (m.toys || []).some(function (o) { return o.p.sp; }),
      result_url: absUrl(urlFor(ans))
    };
  }
  function sendPlan(email) {
    var m = current; if (!m) return Promise.reject(new Error('no result'));
    var ans = m.ans, prof = { quiz_age_band: ans.age, quiz_focus: ans.focus.slice(), quiz_loves: ans.loves.slice(), quiz_home: ans.home.slice() };
    if (!mailUid) mailUid = 'mwq-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    var sub = { data: { type: 'subscription', attributes: { custom_source: MAIL.source || 'Parent quiz', profile: { data: { type: 'profile', attributes: { email: email, properties: prof, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: MAIL.list || '' } } } } };
    var ev = { data: { type: 'event', attributes: { properties: planProps(m), unique_id: mailUid, metric: { data: { type: 'metric', attributes: { name: MAIL.metric || 'Quiz Completed' } } }, profile: { data: { type: 'profile', attributes: { email: email, properties: prof } } } } } };
    return kpost('subscriptions', sub).then(function () { return kpost('events', ev); });
  }
  var mailForm = mail && mail.querySelector('[data-mail-form]');
  if (mailForm) mailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    texts();
    if (mailBusy) return;
    var inp = mailForm.querySelector('input[type="email"]'), btn = mailForm.querySelector('[data-mail-btn]'), ok = mailForm.querySelector('[data-mail-ok]'), er = mailForm.querySelector('[data-mail-err]');
    var lab = mailForm.querySelector('[data-mail-lab]'), busy = mailForm.querySelector('[data-mail-busy]'), v = String(inp && inp.value || '').trim();
    if (ok) ok.hidden = true; if (er) er.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { inp.setAttribute('aria-invalid', 'true'); er.textContent = MAIL.err_email || ''; er.hidden = false; inp.focus(); return; }
    inp.removeAttribute('aria-invalid');
    if (root.getAttribute('data-preview') !== 'false') { ok.textContent = MAIL.preview || ''; ok.hidden = false; return; }   /* preview / editor: nothing is sent */
    mailBusy = true; btn.setAttribute('aria-busy', 'true'); if (lab) lab.hidden = true; if (busy) busy.hidden = false;
    sendPlan(v).then(function () {
      if (current) publish('mirthwell:quiz_email', { band: current.ans.age, focus: current.ans.focus.join(','), plan_for: current.gift ? 'gift' : 'me' });
      if (sheetQid) sheetSend({ qid: sheetQid, update: 'email' });
      mail.classList.add('is-sent'); ok.textContent = MAIL.ok || ''; ok.hidden = false; ok.setAttribute('tabindex', '-1'); ok.focus({ preventScroll: true });
    }, function () {
      er.textContent = MAIL.err_send || ''; er.hidden = false;
    }).then(function () { mailBusy = false; btn.removeAttribute('aria-busy'); if (lab) lab.hidden = false; if (busy) busy.hidden = true; });
  });

  /* ---------------- events ---------------- */
  startBtn.addEventListener('click', startQuiz);
  dlg.addEventListener('click', function (e) {
    var t = e.target.closest('[data-v]');
    if (!t || !dlg.contains(t) || running) return;
    var q = t.closest('[data-q]').getAttribute('data-q'), v = t.getAttribute('data-v');
    if (q === 'focus') { if (t.getAttribute('aria-disabled') === 'true') flashFull(); else toggleFocus(v); }
    else if (q === 'loves') toggleLove(v);
    else choose(q, v);
  });
  dlg.addEventListener('change', function (e) {
    var el = e.target; if (!el || el.type !== 'checkbox') return;
    var name = el.closest('[data-q]').getAttribute('data-q');
    if (name !== 'home') return;
    if (el.value === 'none') { state.homeNone = el.checked; if (el.checked) state.home = []; }
    else { state.homeNone = false; state.home = [].filter.call(STEP.home.querySelectorAll('input:checked'), function (c) { return c.value !== 'none'; }).map(function (c) { return c.value; }); }
    syncStep('home');
    footLabel();
  });
  nextBtn.addEventListener('click', function () { if (!running) advance(); });
  if (goBtn) goBtn.addEventListener('click', function () { if (running && goNext) goNext(); });
  var rGo = resumeEl && resumeEl.querySelector('[data-resume-go]'), rNew = resumeEl && resumeEl.querySelector('[data-resume-new]');
  if (rGo) rGo.addEventListener('click', resumeGo);
  if (rNew) rNew.addEventListener('click', resumeNew);
  backBtn.addEventListener('click', function () { var st = history.state || {}; if (st.mwqb || (typeof st.mwq === 'number' && st.mwq > 0)) history.back(); });
  closeBtn.addEventListener('click', closeQuiz);
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeQuiz(); });
  window.addEventListener('popstate', function (e) {
    var st = e.state, wasMoment = stopMoment();
    if (st && typeof st.mwq === 'number') { var dir = (wasMoment || st.mwq < at) ? 'back' : 'fwd'; openDialogOnly(); showStep(st.mwq, dir); return; }
    if (st && st.mwqb && state.age) { openDialogOnly(); finish(true); return; }
    if (thinkEl) thinkEl.hidden = true;
    var wasOpen = dlg.open;
    if (wasOpen && resumeEl && resumeEl.hidden) saveProgress();
    closeDialog();
    var a = readUrl();
    if (a) { if (!current || current.ans.age !== a.age || urlFor(current.ans) !== urlFor(a)) { state = { age: a.age, who: a.who, focus: a.focus.slice(), loves: a.loves.slice(), home: a.home.slice() }; showResult(a, false); } }
    else showStart();
    if (wasOpen) restoreFocus();
  });
  resWrap.addEventListener('click', function (e) {
    var cb = e.target.closest('[data-cart]'); if (cb) { addToCart(cb); return; }
    var b = e.target.closest('[data-act]'); if (!b) return;
    var act = b.getAttribute('data-act');
    if (act === 'edit') openQuiz(b);
    else if (act === 'share') {
      var lab = b.querySelector('span'), url = location.href, note = resWrap.querySelector('[data-share-note]');
      var done = function () { if (lab) { lab.textContent = T.share_done; setTimeout(function () { lab.textContent = T.share; }, 2500); } };
      var fail = function () { if (note) { note.hidden = false; note.textContent = url; } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, fail); else fail();
    } else if (act === 'to-mail' && mail) {
      scrollToEl(mail, true);
      var inp = mail.querySelector('input[type="email"]'); if (inp) inp.focus({ preventScroll: true });
    }
  });

  window.MWQuiz = {
    version: '2026-10-11-v7', bands: BANDS, under3: UNDER3, maxToys: MAX_TOYS, maxFocus: MAX_FOCUS,
    load: function () { texts(); return loadIndex().then(function () { return true; }); },
    get products() { return PRODUCTS || []; },
    get blocked() { texts(); return BLOCKED; },
    get labels() { return texts().labels; },
    normalize: normalize, eligible: eligible, minAge: minAge, compute: compute, render: render,
    whyText: function (o, ans) { texts(); return whyText(o, ans); }, summary: function (m) { texts(); return sumHead(m); }, planProps: function (m) { texts(); return planProps(m); }
  };

  /* ---------------- start ---------------- */
  var fromUrl = readUrl();
  if (fromUrl) {
    try { history.replaceState({ mwqr: 1, k: KEY }, '', location.href); } catch (e) {}
    state = { age: fromUrl.age, who: fromUrl.who, focus: fromUrl.focus.slice(), loves: fromUrl.loves.slice(), home: fromUrl.home.slice() };
    showResult(fromUrl, false);
  } else {
    document.documentElement.classList.remove('mwq-r-pending');
  }
})();
